import { Car } from '@upstart/harmony/lib/legos/carTypes';
import BackendService from './BackendService';

export default class DecodeService {
  static getRecentModels(makes?: string) {
    const params = { makes };
    return BackendService.get(`/decoder/recentModelsBrands`, {
      params,
      cache: true,
    });
  }

  static getTrimsForModel({
    dealerId,
    year,
    make,
    model,
  }: {
    dealerId: string;
    year: string | number;
    make: string;
    model: string;
  }) {
    return BackendService.get(
      `/decoder/trims/${dealerId}/${year}/${make}/${model}`,
      { cache: true },
    );
  }

  static decodeVin(vin: string, dealerId: string): Promise<Partial<Car>> {
    return BackendService.get(`/decoder/decodeVin/${vin}/${dealerId}`);
  }

  static decodeVinForTradeIn(
    vin: string,
    dealerId: string,
  ): Promise<Partial<Car>> {
    return BackendService.get(
      `/decoder/checkStatusThenDecodeVin/${vin}/${dealerId}`,
    );
  }

  static decodeWithoutVin({
    year,
    model,
    make,
  }: {
    year: string;
    make: string;
    model: string;
  }): Promise<{ carImg?: string }> {
    return BackendService.get(
      `/decoder/describeVehicle/${year}/${make}/${model}`,
    );
  }
}
